// src/pages/TermsAndConditions.jsx

import "../css/Terms.css";
import Footerlanding from '../landing/Footerlanding';
import Navbarlanding from '../landing/Navbarlanding';

    const TermsAndConditions = () => {
    return (
        <div className="terms-page">
        <Navbarlanding />

        <div className="terms-wrapper">
            <h1>Terms &amp; Conditions</h1>
            <p>Last updated: [Date]</p>

            <section>
            <h2>1. Introduction</h2>
            <p>
                Welcome to Techvision (“we”, “us”, “our”). These Terms &amp;
                Conditions govern your access to and use of our website and
                services. By accessing or using our website, you agree to these
                Terms &amp; Conditions. If you do not agree, please do not use our
                services.
            </p>
            </section>

            <section>
            <h2>2. Definitions</h2>
            <p>
                <strong>“Service”</strong> refers to our website and any
                services provided through it. <br />
                <strong>“User”</strong> means any person accessing or using the
                Service. <br />
                <strong>“Content”</strong> includes text, images, videos, links,
                and any other material provided on our Service.
            </p>
            </section>

            <section>
            <h2>3. Use of the Service</h2>
            <p>
                You agree to use the Service only for lawful purposes, and in a
                manner consistent with these Terms and applicable laws. You
                further agree not to:
            </p>
            <ul>
                <li>Use the Service in violation of any applicable law or regulation</li>
                <li>Attempt to gain unauthorized access to any part or feature of the Service</li>
                <li>Interfere with or disrupt the Service or servers or networks</li>
                <li>Use any robot, spider, crawler, or other automated means to access the Service</li>
            </ul>
            </section>

            <section>
            <h2>4. Account Registration (if applicable)</h2>
            <p>
                Some parts of the Service may require you to register an account.
                You are responsible for maintaining the confidentiality of your
                account credentials and for all activities that occur under your
                account. You must notify us immediately if your credentials are
                compromised.
            </p>
            </section>

            <section>
            <h2>5. Intellectual Property</h2>
            <p>
                All content, trademarks, logos, and materials on the Service are
                owned by or licensed to Techvision and are protected by
                intellectual property laws. You may not copy, reproduce,
                distribute, or create derivative works of any content without our
                prior written permission.
            </p>
            </section>

            <section>
            <h2>6. Disclaimer of Warranties</h2>
            <p>
                The Service is provided “as is” and “as available.” We make no
                warranties, express or implied, including warranties of
                merchantability, fitness for a particular purpose, or
                non-infringement. We do not guarantee continuous, uninterrupted,
                or error-free access to the Service.
            </p>
            </section>

            <section>
            <h2>7. Limitation of Liability</h2>
            <p>
                To the fullest extent permitted by law, Techvision is not liable
                for any indirect, incidental, special, consequential, or punitive
                damages arising out of your use of the Service. Our total
                liability to you is limited to the amount you paid (if any) to us.
            </p>
            </section>

            <section>
            <h2>8. Indemnification</h2>
            <p>
                You agree to indemnify, defend, and hold harmless Techvision and
                its officers, directors, employees, and agents from all claims,
                damages, losses, liabilities, and costs (including legal fees)
                arising out of or related to (a) your use of the Service, (b)
                violation of these Terms, or (c) violation of any rights of a
                third party.
            </p>
            </section>

            <section>
            <h2>9. Modifications to Terms</h2>
            <p>
                We reserve the right to modify these Terms &amp; Conditions at any
                time. Changes become effective upon posting the updated Terms on
                this page. Your continued use after changes indicates acceptance
                of the new terms.
            </p>
            </section>

            <section>
            <h2>10. Governing Law & Jurisdiction</h2>
            <p>
                These Terms shall be governed by and construed in accordance with
                the laws of [State / Country], without regard to its conflict of
                law principles. All disputes arising shall be subject to the
                exclusive jurisdiction of courts in [City / State].
            </p>
            </section>

            <section>
            <h2>11. Contact Information</h2>
            <p>
                If you have any questions or concerns regarding these Terms &
                Conditions, you may contact us at: <br />
                Email: info@yourdomain.com <br />
                Address: Your Company Address
            </p>
            </section>
        </div>

        <Footerlanding />
        </div>
    );
    };

    export default TermsAndConditions;